import { useContext } from "react";
import PropTypes from "prop-types";

import { CompanyContext } from "../CompanyList/CompanyContext";

export const BaseLicensingNumber = ({
	displayName = "#",
	field,
	className,
}) => {
	const { company } = useContext(CompanyContext);
	const licensingNumber = company.fields[field];
	if (!licensingNumber) return null;

	return <div className={className}>{`${displayName} ${licensingNumber}`}</div>;
};

BaseLicensingNumber.propTypes = {
	displayName: PropTypes.string,
	field: PropTypes.oneOf(["dotNumber", "nmlsNumber"]).isRequired,
	className: PropTypes.string,
};
